import { mapGetters } from 'vuex';
import { EBcDeviceType } from '@/classes/BcEnums';
import BcToast from './Toast.vue';
class PluginOptions {
}
class BcPlugin {
    // eslint-disable-next-line no-useless-constructor
    constructor() {
        // console.log('common plugin init.')
    }
    checkClientBrowser() {
        const _userAgent = window.navigator.userAgent;
        let _broMark = '';
        if (/DingTalk/gi.test(_userAgent)) { // 判断是否是钉钉客户端
            _broMark = 'DingTalk';
            return _broMark;
        }
        else if (/wxWork/gi.test(_userAgent)) { // 判断是否是微信客户端
            _broMark = 'wxWork';
            return _broMark;
        }
        // 如果是手机浏览器
        if (/Mobile/gi.test(_userAgent)) {
            if (/MicroMessenger/gi.test(_userAgent)) {
                _broMark = 'wx';
            }
            else if (/ycBrowser/gi.test(_userAgent)) {
                _broMark = 'yx';
            }
            else {
                _broMark = 'mobileBrowser';
            }
        }
        else {
            _broMark = 'PC';
        }
        return _broMark;
    }
    install(Vue, options) {
        // 注入组件
        Vue.mixin({
            computed: {
                ...mapGetters({})
            },
            data: () => ({
                navigationDrawer: true,
            }),
            methods: {
                test() {
                    console.log('common test method.');
                },
            }
        });
        // 全局过滤器
        // 时间格式化过滤器(带参数)
        // 示例(.vue): {{msg | dateFormat('yyyy-MM-dd hh:m:ss')}}
        // js: Vue.filter('dateFormat')(new Date(), 'yyyy-MM-dd')
        Vue.filter('dateFormat', (value, vformat) => {
            /* eslint-disable */
            // @ts-ignore
            var work = (_date, format) => {
                var date = {
                    'M+': _date.getMonth() + 1,
                    'd+': _date.getDate(),
                    'h+': _date.getHours(),
                    'm+': _date.getMinutes(),
                    's+': _date.getSeconds(),
                    'q+': Math.floor((_date.getMonth() + 3) / 3),
                    'S+': _date.getMilliseconds()
                };
                if (/(y+)/i.test(format)) {
                    format = format.replace(RegExp.$1, (_date.getFullYear() + '').substr(4 - RegExp.$1.length));
                }
                for (var k in date) {
                    if (new RegExp('(' + k + ')').test(format)) {
                        format = format.replace(RegExp.$1, RegExp.$1.length == 1
                            // @ts-ignore
                            ? date[k] : ('00' + date[k]).substr(('' + date[k]).length));
                    }
                }
                return format;
            };
            var r = work(new Date(value), vformat);
            // @ts-ignore
            return isNaN(new Date(r)) ? '' : r;
        });
        // 数组比较函数
        // 示例: Vue.filter('arrayEqual')([1,2,4], [1,2,4]) => true
        Vue.filter('arrayEqual', (src, array, key) => {
            if (!array)
                return false;
            // compare lengths - can save a lot of time
            if (src.length != array.length)
                return false;
            for (var i = 0, l = src.length; i < l; i++) {
                // Check if we have nested arrays
                if (src[i] instanceof Array && array[i] instanceof Array) {
                    // recurse into the nested arrays
                    if (!src[i].equals(array[i]))
                        return false;
                }
                else if (src[i] != array[i]) {
                    // Warning - two different object instances will never be equal: {x:20} != {x:20}
                    return false;
                }
            }
            return true;
        }); // 秒转换成时、分、秒格式
        // 示例(.vue): {{msg | formatSeconds}}
        // 示例: Vue.filter('formatSeconds')(1316) => '21分56秒'
        Vue.filter('formatSeconds', (value) => {
            if (!String(value).length || !value || /undefined|null/i.test(String(value)))
                return '';
            let result = parseInt(String(value));
            let h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600);
            let m = Math.floor((result / 60 % 60)) < 10 ? '0' + Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60));
            let s = Math.floor((result % 60)) < 10 ? '0' + Math.floor((result % 60)) : Math.floor((result % 60));
            let res = '';
            if (h !== '00')
                res += `${h}时`;
            if (m !== '00')
                res += `${m}分`;
            res += `${s}秒`;
            return res;
        });
        Vue.filter('checkClientBrowser', () => {
            return this.checkClientBrowser();
        });
        // 组件调用方法:
        // .vue文件中<BcToast ref='toast'></BcToast>
        // script中调用: this.$refs.toast.info('example text.')
        // info 还可为success/warn/error或open进行自定义
        Vue.component(BcToast.name, BcToast);
        // Vue.component(BcDialog.name, BcDialog)
    }
    /**
     * 获取设备类型
     * @param type 设备类型
     * @param mode 设备型号
     * @returns {string} 返回设备类型枚举值
     */
    getDeviceCategory(type, mode) {
        if (/^apt$|^al$|综合|多功能/i.test(type) || /al-0|apt-0/i.test(mode))
            return EBcDeviceType.Auto;
        if (/^ampul$|台式安瓿/i.test(type) || /ab-0/i.test(mode))
            return EBcDeviceType.Ampul;
        if (/^xilin$|台式西林/i.test(type) || /xl-0/i.test(mode))
            return EBcDeviceType.Xilin;
        if (/^liquid$|分液|sepera/i.test(type) || /ls-0/i.test(mode))
            return EBcDeviceType.Liquid;
        if (/^pd$|预溶|pro/i.test(type) || /pd-0/i.test(mode))
            return EBcDeviceType.PreDissolve;
        if (/^iemc$|挂镜/i.test(type) || /iemc-0/i.test(mode))
            return EBcDeviceType.EndoscopeArk;
        if (/^ew$|清洗|洗消/i.test(type) || /ew-0/i.test(mode))
            return EBcDeviceType.CleaningMachine;
        if (/^rtdc$|呼吸训练/i.test(type) || /rtdc-0/i.test(mode))
            return EBcDeviceType.BreathTrain;
        return EBcDeviceType.Other;
    }
}
export var BcCommon = new BcPlugin();
